import { render } from "./TheProfessionalCalendar.vue?vue&type=template&id=3cb3c520&ts=true"
import script from "./TheProfessionalCalendar.vue?vue&type=script&lang=ts"
export * from "./TheProfessionalCalendar.vue?vue&type=script&lang=ts"

import "./TheProfessionalCalendar.vue?vue&type=style&index=0&id=3cb3c520&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__